import { Box, Grid, Chip } from '@mui/material';
import moment from 'moment';
import { ColaboradorPaqueteBitacora } from '../../../interfaces/Prestaciones.interface';

const TIPO_CONFIG: Record<string, { label: string; bg: string }> = {
  ASIGNACION:   { label: 'Asignación',   bg: '#c8e6c9' },
  REASIGNACION: { label: 'Reasignación', bg: '#bbdefb' },
  APROBACION:   { label: 'Aprobación',   bg: '#c8e6c9' },
  RECHAZO:      { label: 'Rechazo',      bg: '#ffccbc' },
};

interface Props {
  event: ColaboradorPaqueteBitacora;
  color: 'blue' | 'dark-blue';
}

const parseFecha = (fecha: string) => {
  const num = Number(fecha);
  return !isNaN(num) && fecha.trim() !== '' ? moment.utc(num) : moment.utc(fecha);
};

const ColaboradorPaqueteHistorialTimelineRow = ({ event, color }: Props) => {
  const config = TIPO_CONFIG[event.tipoMovimiento] ?? { label: event.tipoMovimiento, bg: '#f5f5f5' };
  const fecha = parseFecha(event.fechaSolicitud);

  return (
    <Box id="timeline-row">
      <Grid container alignItems="center">
        <Grid item xs={4} md={3}>
          <Box className="date-container">
            <p className="date-label">
              {fecha.format('DD MMM YYYY').toUpperCase().replace('.', '')}
            </p>
          </Box>
        </Grid>
        <Grid item xs={8} md={9}>
          <Box className="description-container">
            <div className={`dot dot-${color}`} />
            <Box className="description-card">
              <Chip
                label={config.label}
                size="small"
                sx={{ backgroundColor: config.bg, mb: 1, fontFamily: 'Roboto', fontSize: 12 }}
              />
              <p className="description-title">
                {event.nombrePaquete ?? '—'}
                {event.nombrePaqueteAnterior && (
                  <span style={{ color: '#888', fontWeight: 400 }}>
                    {' '}(antes: {event.nombrePaqueteAnterior})
                  </span>
                )}
              </p>
              {event.motivo && (
                <p className="description-text">Motivo: {event.motivo}</p>
              )}
              <p className="description-text">Solicitado por: {event.nombreSolicitante ?? '—'}</p>
              {event.nombreAprobador && (
                <p className="description-text">
                  {event.tipoMovimiento === 'RECHAZO' ? 'Rechazado' : 'Aprobado'} por: {event.nombreAprobador}
                  {event.fechaAprobacion && (
                    <span style={{ color: '#888' }}>
                      {' '}· {parseFecha(event.fechaAprobacion).format('DD MMM YYYY').toUpperCase().replace('.', '')}
                    </span>
                  )}
                </p>
              )}
              {event.comentarioAprobacion && (
                <p className="description-text" style={{ fontStyle: 'italic' }}>
                  "{event.comentarioAprobacion}"
                </p>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ColaboradorPaqueteHistorialTimelineRow;
